namespace RioERP.Orders {
    export interface OrderProductSpecificationsForm {
        OrderId: Serenity.LookupEditor;
        OrderProductsId: Serenity.LookupEditor;
        ProductSpecificationId: Serenity.LookupEditor;
    }

    export class OrderProductSpecificationsForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.OrderProductSpecifications';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderProductSpecificationsForm.init)  {
                OrderProductSpecificationsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;

                Q.initFormType(OrderProductSpecificationsForm, [
                    'OrderId', w0,
                    'OrderProductsId', w0,
                    'ProductSpecificationId', w0
                ]);
            }
        }
    }
}
